<script>
  import { ShopboxWidgetCustomizationApp } from '@shopboxai/sb-widget-customization-app';
  import { currentUser } from '../stores';
</script>

<ShopboxWidgetCustomizationApp user={$currentUser} />
